import React, { history, useEffect, useState, useMemo } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import $, { parseJSON } from 'jquery';
import { useHistory, useNavigate } from "react-router-dom";
import Services from "../../services/services";
const SubscribeToCareer = () => {
  const [categories, setCategory] = useState([]);
  const navigate = useNavigate();
  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
    setError,
    clearErrors,
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  const {
    register: register1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  const {
    register: register2,
    formState: { errors: errors2 },
    handleSubmit: handleSubmit2,
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  const submitValue = () => {


    var catofExpertiseArray = [];
    $.each($("input[name='category']:checked"), function () {
      catofExpertiseArray.push($(this).val());
    });
    var phone_val = $("#yourphone2").val();
    //phone_val = "1234567899";


    // Mapping: Category Name → Mailchimp Merge Field Key
    const categoryMergeFieldMap = {
      "Accounting": "accounting",
      "Advanced Manufacturing (Robotics, Welding, CNC)": "adv_mfg",
      "Advertising and PR Services": "adv_pr",
      "Agriculture and Food Processing": "agri_food",
      "Architectural and Design Services": "arc_design",
      "Art": "art",
      "Athletic Training/Physical/Occupational Therapy": "athletic",
      "Auto/Diesel Technology": "auto_diesel",
      "Banking/Financial Management": "banking",
      "Business and Administrative Services": "business",
      "Computer Networking/Network Security": "comp_net",
      "Computer Programming/Web Programming": "comp_prog",
      "Construction Technologies": "const_tech",
      "Culinary Arts": "culinary",
      "Dental Hygiene": "dental",
      "Distribution/Warehousing": "dist_ware",
      "Education": "education",
      "Engineering and Science Technologies": "eng_sci",
      "Government, Law & Public Safety": "gov_law",
      "Graphic Design": "graphics",
      "Healthcare Services": "health_srv",
      "Hospitality and Tourism": "hosp_tour",
      "Human Resources": "hr",
      "Information Technology": "it",
      "IT": "infotech",
      "Insurance and Financial Services": "ins_fin",
      "Journalism": "journalism",
      "Manufacturing": "mfg",
      "Nursing": "nursing",
      "Pharmaceuticals": "pharma",
      "Printing and Publishing": "printing",
      "Professional Services": "prof_srv",
      "Psychology/Sociology": "psych_soc",
      "Radiographic Imaging (X-Ray/Ultrasound)": "imaging",
      "Real Estate/Property Management": "real_estat",
      "Respiratory Care": "resp_care",
      "Retail": "retail",
      "Sales and Marketing": "sales_mktg",
      "Skilled Trades/Maintenance": "skilled",
      "Social Work/Human Services": "soc_work",
      "Supply Chain Management": "supp_mgmt",
      "Telecommunications": "telecom",
      "Transportation and Logistics": "transport",
      "Veterinary Medicine": "vet_meds"
    };


    // Start with name fields
    const mergeFields = {
      FNAME: $('#firstName').val(),
      LNAME: $('#lastName').val()
    };

    // Add only selected categories as TRUE (optional: mark others as FALSE)
    catofExpertiseArray.forEach(function (selectedCat) {
      const mergeKey = categoryMergeFieldMap[selectedCat];
      if (mergeKey) {
        //mergeFields[mergeKey] = "TRUE";
        mergeFields[mergeKey.toUpperCase()] = "TRUE";
      }
    });


    const requestObject = {

      "email_address": $('#email').val(),
      "status": "subscribed",
      // "merge_fields":
      // {
      //   "FNAME": $('#firstName').val(),
      //   "LNAME": $('#lastName').val(),
      // },
      "merge_fields": mergeFields,
      "tags": catofExpertiseArray

    }
    console.log(requestObject);
    var mailchimpAPIkey = "683b53336a0d9d79dad6e9e6e9da46d4";
    var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'data-type': 'jsonp',
      },
      body: JSON.stringify(requestObject)
    };

    Services.careerMemberSubscribe(requestOptions).then((res) => {


      navigate('/thankyou?r=3');

    });




  }

  const submitValue_custom = () => {

    const firstName = getValues("firstName");
    const lastName = getValues("lastName");
    const email = getValues("email");
    const categories = getValues("category") || [];

    let valid = true;
    // First Name validation
    if (!firstName) {
      setError("firstName", { type: "manual", message: "First name is required" });
      valid = false;
    } else if (firstName.length < 2 || firstName.length > 50) {
      setError("firstName", { type: "manual", message: "First name must be at least 2 characters" });
      valid = false;
    }

    // Last Name validation
    if (!lastName) {
      setError("lastName", { type: "manual", message: "Last name is required" });
      valid = false;
    } else if (lastName.length < 2 || lastName.length > 50) {
      setError("lastName", { type: "manual", message: "Last name must be at least 2 characters" });
      valid = false;
    }

    // Email validation
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email) {
      setError("email", { type: "manual", message: "Email is required" });
      valid = false;
    } else if (!emailPattern.test(email)) {
      setError("email", { type: "manual", message: "Please provide a valid email" });
      valid = false;
    }

    // Category validation (at least one must be selected)
    if (categories.length === 0) {
      setError("category", { type: "manual", message: "Please select at least one category" });
      valid = false;
    }

    //alert(valid);

    if (valid) {

      var catofExpertiseArray = [];
      $.each($("input[name='category']:checked"), function () {
        catofExpertiseArray.push($(this).val());
      });
      var phone_val = $("#yourphone2").val();
      //phone_val = "1234567899";

      // Mapping: Category Name → Mailchimp Merge Field Key
      const categoryMergeFieldMap = {
        "Accounting": "accounting",
        "Advanced Manufacturing (Robotics, Welding, CNC)": "adv_mfg",
        "Advertising and PR Services": "adv_pr",
        "Agriculture and Food Processing": "agri_food",
        "Architectural and Design Services": "arc_design",
        "Art": "art",
        "Athletic Training/Physical/Occupational Therapy": "athletic",
        "Auto/Diesel Technology": "auto_diesel",
        "Banking/Financial Management": "banking",
        "Business and Administrative Services": "business",
        "Computer Networking/Network Security": "comp_net",
        "Computer Programming/Web Programming": "comp_prog",
        "Construction Technologies": "const_tech",
        "Culinary Arts": "culinary",
        "Dental Hygiene": "dental",
        "Distribution/Warehousing": "dist_ware",
        "Education": "education",
        "Engineering and Science Technologies": "eng_sci",
        "Government, Law & Public Safety": "gov_law",
        "Graphic Design": "graphics",
        "Healthcare Services": "health_srv",
        "Hospitality and Tourism": "hosp_tour",
        "Human Resources": "hr",
        "Information Technology": "it",
        "IT": "infotech",
        "Insurance and Financial Services": "ins_fin",
        "Journalism": "journalism",
        "Manufacturing": "mfg",
        "Nursing": "nursing",
        "Pharmaceuticals": "pharma",
        "Printing and Publishing": "printing",
        "Professional Services": "prof_srv",
        "Psychology/Sociology": "psych_soc",
        "Radiographic Imaging (X-Ray/Ultrasound)": "imaging",
        "Real Estate/Property Management": "real_estat",
        "Respiratory Care": "resp_care",
        "Retail": "retail",
        "Sales and Marketing": "sales_mktg",
        "Skilled Trades/Maintenance": "skilled",
        "Social Work/Human Services": "soc_work",
        "Supply Chain Management": "supp_mgmt",
        "Telecommunications": "telecom",
        "Transportation and Logistics": "transport",
        "Veterinary Medicine": "vet_meds"
      };

      // Start with name fields
      const mergeFields = {
        FNAME: $('#firstName').val(),
        LNAME: $('#lastName').val()
      };

      // Add only selected categories as TRUE (optional: mark others as FALSE)
      catofExpertiseArray.forEach(function (selectedCat) {
        const mergeKey = categoryMergeFieldMap[selectedCat];
        if (mergeKey) {
          //mergeFields[mergeKey] = "TRUE";
          mergeFields[mergeKey.toUpperCase()] = "TRUE";
        }
      });


      const requestObject = {

        "email_address": $('#email').val(),
        "status": "subscribed",
        // "merge_fields":
        // {
        //   "FNAME": $('#firstName').val(),
        //   "LNAME": $('#lastName').val(),
        // },
        "merge_fields": mergeFields,
        "tags": catofExpertiseArray

      }
      console.log(requestObject);
      var mailchimpAPIkey = "683b53336a0d9d79dad6e9e6e9da46d4";
      var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'data-type': 'jsonp',
        },
        body: JSON.stringify(requestObject)
      };

      Services.careerMemberSubscribe(requestOptions).then((res) => {


        navigate('/thankyou?r=3');

      });

    }


  }

  const submitValue1 = () => {

    $('#step1').hide();
    $('#step2').show();

  }

  const getIndustryData = () => {
    Services.getIndustryData().then((res) => {
      console.log("Industry data=" + JSON.stringify(res.data));
      setCategory(res.data.content);
    });
  }

  const submitValue2 = () => {


    var catofExpertiseArray = [];
    $.each($("input[name='category_m']:checked"), function () {
      catofExpertiseArray.push($(this).val());
    });
    var phone_val = $("#yourphone2").val();


    // Mapping: Category Name → Mailchimp Merge Field Key
    const categoryMergeFieldMap = {
      "Accounting": "accounting",
      "Advanced Manufacturing (Robotics, Welding, CNC)": "adv_mfg",
      "Advertising and PR Services": "adv_pr",
      "Agriculture and Food Processing": "agri_food",
      "Architectural and Design Services": "arc_design",
      "Art": "art",
      "Athletic Training/Physical/Occupational Therapy": "athletic",
      "Auto/Diesel Technology": "auto_diesel",
      "Banking/Financial Management": "banking",
      "Business and Administrative Services": "business",
      "Computer Networking/Network Security": "comp_net",
      "Computer Programming/Web Programming": "comp_prog",
      "Construction Technologies": "const_tech",
      "Culinary Arts": "culinary",
      "Dental Hygiene": "dental",
      "Distribution/Warehousing": "dist_ware",
      "Education": "education",
      "Engineering and Science Technologies": "eng_sci",
      "Government, Law & Public Safety": "gov_law",
      "Graphic Design": "graphics",
      "Healthcare Services": "health_srv",
      "Hospitality and Tourism": "hosp_tour",
      "Human Resources": "hr",
      "Information Technology": "it",
      "IT": "infotech",
      "Insurance and Financial Services": "ins_fin",
      "Journalism": "journalism",
      "Manufacturing": "mfg",
      "Nursing": "nursing",
      "Pharmaceuticals": "pharma",
      "Printing and Publishing": "printing",
      "Professional Services": "prof_srv",
      "Psychology/Sociology": "psych_soc",
      "Radiographic Imaging (X-Ray/Ultrasound)": "imaging",
      "Real Estate/Property Management": "real_estat",
      "Respiratory Care": "resp_care",
      "Retail": "retail",
      "Sales and Marketing": "sales_mktg",
      "Skilled Trades/Maintenance": "skilled",
      "Social Work/Human Services": "soc_work",
      "Supply Chain Management": "supp_mgmt",
      "Telecommunications": "telecom",
      "Transportation and Logistics": "transport",
      "Veterinary Medicine": "vet_meds"
    };

    // Start with name fields
    const mergeFields = {
      FNAME: $('#firstName').val(),
      LNAME: $('#lastName').val()
    };

    // Add only selected categories as TRUE (optional: mark others as FALSE)
    catofExpertiseArray.forEach(function (selectedCat) {
      const mergeKey = categoryMergeFieldMap[selectedCat];
      if (mergeKey) {
        //mergeFields[mergeKey] = "TRUE";
        mergeFields[mergeKey.toUpperCase()] = "TRUE";
      }
    });
    const requestObject = {

      "email_address": $('#email_m').val(),
      "status": "subscribed",
      "merge_fields": mergeFields,
      // "merge_fields":
      // {
      //   "FNAME": $('#firstName_m').val(),
      //   "LNAME": $('#lastName_m').val(),
      // },
      "tags": catofExpertiseArray

    }
    console.log(requestObject);
    var mailchimpAPIkey = "683b53336a0d9d79dad6e9e6e9da46d4";
    var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'data-type': 'jsonp',
      },
      body: JSON.stringify(requestObject)
    };

    Services.careerMemberSubscribe(requestOptions).then((res) => {


      navigate('/thankyou?r=3');

    });


    navigate('/subscribeToCareer');

  }

  useEffect(() => {
    const jsonData = {
      "subscribeToCareer": {

      }
    };

    var jsondataformatted = JSON.stringify(jsonData);
    sessionStorage.setItem('pagejsonObject', jsondataformatted);

    $('#step1').show();
    $('#step2').hide();
    getIndustryData();



  }, []);
  return (
    <>
      <main class="empr-directory-main">
        <div class="main-bgpatten"></div>
        <section class="headtitle-wrap">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <nav style={{ "--bs-breadcrumb-divider": "'>'" }} aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item headtitle "><a href="#">Subscribe to Career</a></li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- info typography --> */}
        <section class="company-detail-wrap py-5 cd-desktop ">
          <div class="container">
            <div class="row">
              <div class="col-12 ">
                <form onSubmit={handleSubmit(submitValue)}>
                  <div class="white-bg px-5 pt-4 pb-4">
                    <div class="row mt-4 resume-wrap">


                      <div class="col-lg-6 mb-4">
                        <label for="firstName" class="form-label">First Name<span class="red-text">*</span></label>
                       

                        <input
                          type="text"
                          className="form-control"
                          id="firstName"
                          {...register("firstName")}
                        />
                        {errors.firstName && <div className="error">{errors.firstName.message}</div>}
                      </div>

                      <div class="col-lg-6 mb-4">
                        <label for="firstName" class="form-label">Last Name<span class="red-text">*</span></label>
                       
                        <input
                          type="text"
                          className="form-control"
                          id="lastName"
                          {...register("lastName")}
                        />
                        {errors.lastName && <div className="error">{errors.lastName.message}</div>}
                      </div>

                      <div class="col-lg-6 mb-4">
                        <label for="firstName" class="form-label">Email<span class="red-text">*</span></label>
                        

                        <input
                          type="text"
                          className="form-control"
                          id="email"
                          {...register("email")}
                        />
                        {errors.email && <div className="error">{errors.email.message}</div>}
                      </div>

                      <div class="col-lg-12 mb-4">
                        <div class="d-flex"><label for="firstName" class="form-label mr-2 mb-3">Career Industry<span class="red-text">*</span></label></div>

                        <div>
                          <div class="category-check-itm">
                            <ul class="category-check">
                              {
                                categories.map((data, index) => (
                                  <li><input class="form-check-input" type="checkbox" name="category" value={data.name} id="defaultCheck1" {...register('category', { required: true })} />  <label class="form-check-label" for="defaultCheck1"> {data.name} </label></li>
                                ))}

                            </ul>
                          </div>


                          {errors.category && <div className="error">{errors.category.message}</div>}
                        </div>

                      </div>

                      <div class="col-lg-12 mb-4">

                        <div class="d-flex justify-content-between align-items-end choose">

                          <div><button type="button" className="reg-button" onClick={submitValue_custom}>
                            Subscribe
                          </button></div>
                        </div>

                      </div>

                    </div>



                  </div>

                </form>

              </div>

            </div>
          </div>
        </section>

        <section class="company-detail-wrap cd-mobile ">
          <div class="white-bg px-5 pt-4 pb-4">

            {/* <!-- step one --> */}

            <div class="row" id="step1">
              <form onSubmit={handleSubmit1(submitValue1)}>
                <div class="text-center">
                  <h1 class="mb-4">
                    <span class=" red-text pb-2 border-bottom ">Step 1:</span>
                  </h1>
                </div>
                <div class="col-lg-6 mb-5">
                  <label for="firstName" class="form-label">First name <span class="red-text">*</span></label>
                  <input type="text" class="form-control" id="firstName_m" placeholder=""   {...register1('firstName', { required: true })} />
                  {errors1.firstName && errors1.firstName.type === "required" && <div class="error">First name is required</div>}
                </div>
                <div class="col-lg-6 mb-5">
                  <label for="firstName" class="form-label">Last name <span class="red-text">*</span></label>
                  <input type="text" class="form-control" id="lastName_m" placeholder=""   {...register1('lastName', { required: true })} />
                  {errors1.lastName && errors1.lastName.type === "required" && <div class="error">Last name is required</div>}
                </div>
                <div class="col-lg-6 mb-5">
                  <label for="firstName" class="form-label">Email <span class="red-text">*</span></label>
                  <input type="text" class="form-control" id="email_m" placeholder=""  {...register1('email', { required: true, pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/ })} />
                  {errors1.email && errors1.email.type === "required" && <div class="error">Email is required</div>}
                  {errors1.email && errors1.email.type === "pattern" && <div class="error">Please provide valid email.</div>}
                </div>

                <div class="mt-4 mb-4">
                  <button type="submit" class="reg-button">Next &gt;&gt;</button>
                </div>
              </form>
            </div>

            {/* <!-- step Two --> */}

            <div class="row" id="step2">
              <form onSubmit={handleSubmit2(submitValue2)}>
                <div class="text-center">
                  <h1 class="mb-4">
                    <span class=" red-text pb-2 border-bottom ">Step 2:</span>
                  </h1>
                </div>

                <div class="col-12 mt-3 p-0">
                  <div class="mobile-form-avl p-3">
                    <div class="category-check-itm">
                      <ul>
                        {
                          categories.map((data, index) => (
                            <li><input class="form-check-input" type="checkbox" name="category_m" value={data.name} id="defaultCheck1" {...register('category_m', { required: true })} />  <label class="form-check-label" for="defaultCheck1"> {data.name} </label></li>
                          ))}

                      </ul>
                    </div>

                  </div>
                  {errors2.career && errors2.career.type === "required" && <div class="error">Career Industry is required</div>}
                </div>
                <div class="mt-4 mb-4">
                  <button type="submit" class="reg-button">Subscribe &gt;&gt;</button>
                </div>
              </form>
            </div>
          </div>
        </section>

      </main>
    </>
  )
};

SubscribeToCareer.propTypes = {};

SubscribeToCareer.defaultProps = {};

export default SubscribeToCareer;
